import type { ThreatLevel } from '@/lib/criteria/levels'

export type RGB = [number, number, number]

/**
 * Brand-blue intensity ramp for the globe's live weather points. Intensity reads
 * through BRIGHTNESS — dim deep blue (low) → bright pale blue (high) — so the most
 * intense systems still pop. The threat levels map onto it lowest→highest; the data
 * (tropical category, SPC risk, alert density) keeps the same levels, just recoloured.
 *
 *   #3f5e9e → #3b82f6 → #5b9bff → #8cc5ff → #dcecff
 */
export const GLOBE_RAMP_RGB: Record<ThreatLevel, RGB> = {
  quiet: [63, 94, 158], // #3f5e9e
  info: [63, 94, 158], // #3f5e9e — lowest
  watch: [59, 130, 246], // #3b82f6
  warning: [91, 155, 255], // #5b9bff
  severe: [140, 197, 255], // #8cc5ff
  extreme: [220, 236, 255], // #dcecff — highest / brightest
}

/** CSS `rgb(...)` for a level on the blue ramp (for the tap sheet etc.). */
export function globeRampCss(level: ThreatLevel): string {
  const [r, g, b] = GLOBE_RAMP_RGB[level]
  return `rgb(${r}, ${g}, ${b})`
}
